import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { CardoCarousel } from '@cotyorg/ccx-organism-carousel';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import SectionHeader from '../../../../atoms/SectionHeader';
import { knowledgeBaseCardoConfig } from './cardo.config';

export const Knowledge = ({ sectionHeadings }) => (
  <div className="knowledge-section">
    <div className="knowledge-section__hero">
      <HeroFullBlock
        heroStoreDataKey="knowledge"
        isContentFirst
        isUnderlined={false}
        breakpointConfig={knowledgeBaseCardoConfig}
      />
    </div>

    <div className="knowledge-section__icons grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading extraClass="section__title" level={2}>
              {R.path(['knowledge', 'heading'])(sectionHeadings)}
            </Heading>

            <Paragraph>
              {R.path(['knowledge', 'introduction'])(sectionHeadings)}
            </Paragraph>
          </SectionHeader>

          <CardoCarousel
            cardoProps={{
              cardoStoreDataKey: 'knowledgeCarousel',
              isTitleUnderlined: false,
              contentTheme: 'transparent',
              headingLevel: 5,
            }}
            carouselProps={{
              carouselsStoreDataKey: 'knowledgeCarousel',
              rightChevronIconSrc: '/ccx-files/assets/arrow-right-blue.svg',
              leftChevronIconSrc: '/ccx-files/assets/arrow-left-blue.svg',
            }}
          />
        </div>
      </div>
    </div>
  </div>
);

Knowledge.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
};
